// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__uwp3y","header":"ReportDetails_header__Gn3Pn","title":"ReportDetails_title__2ge0U","left":"ReportDetails_left__1ggpL"};